import { Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { BrowserStorageService, TranslationService } from '@app/core/services';
import * as momentJalaali from "moment-jalaali";
import * as moment from 'moment-timezone';
import { Subject, takeUntil } from 'rxjs';
import { DateTypes } from '../types/date-type';

@Directive({
    selector: '[tcdate]',
    standalone: true
})
export class TcDateStandaloneDirective implements OnChanges, OnDestroy {

    @Input() value: any;
    @Input() type: DateTypes;
    @Input() seprator: string = ' ';
    @Input() yearsLengthIsTwo: boolean = false;
    isOpen: boolean;
    ellipsisImg: any;
    unsubscribeAll$ = new Subject<void>();

    constructor(
        private el: ElementRef,
        private translationService: TranslationService,
        private browserStorageService: BrowserStorageService
    ) {
        this.setup();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes.value.firstChange) {
            this.setup();
        }
    }

    setup() {
        setTimeout(() => {
            if (this.type === undefined) {
                this.type = DateTypes.DateTime;
            }
            this.setTimeZone();
        }, 50);
    }

    setTimeZone(): void {
        this.translationService.currentLang$
            .pipe(takeUntil(this.unsubscribeAll$))
            .subscribe(lang => {
                let defaultTimeZone = this.browserStorageService.getDefaultTimeZone();
                if (!defaultTimeZone) {
                    defaultTimeZone = moment.tz.guess();
                }

                // ۱) ورودی رو به Date مطمئن تبدیل کن
                const originalDate: Date =
                    this.value instanceof Date ? this.value : new Date(this.value);

                // ۲) فقط یک بار timezone رو اعمال کن
                const m = moment(originalDate).tz(defaultTimeZone);

                // ۳) فرمت بر اساس type + lang
                let format = 'YYYY/MM/DD';

                if (this.type === DateTypes.DateTime && lang === 'fa') {
                    format = 'HH:mm' + this.seprator + 'jYYYY/jMM/jDD';
                } else if (this.type === DateTypes.DateTime && lang !== 'fa') {
                    format = 'YYYY/MM/DD' + this.seprator + 'HH:mm';
                } else if (this.type === DateTypes.Time) {
                    format = 'HH:mm';
                } else if (this.type === DateTypes.TimeSecond) {
                    format = 'HH:mm:ss';
                } else if (this.type === DateTypes.Date && lang === 'fa') {
                    format = this.yearsLengthIsTwo ? 'jYY/jMM/jDD' : 'jYYYY/jMM/jDD';
                } else if (this.type === DateTypes.Date && lang !== 'fa') {
                    format = this.yearsLengthIsTwo ? 'YY/MM/DD' : 'YYYY/MM/DD';
                } else if (this.type === DateTypes.DateWithMonthName && lang === 'fa') {
                    momentJalaali.loadPersian();
                    format = this.yearsLengthIsTwo ? 'jDD jMMMM،jYY' : 'jDD jMMMM،jYYYY';
                } else if (this.type === DateTypes.DateWithMonthName && lang !== 'fa') {
                    format = this.yearsLengthIsTwo ? 'MMM DD,YY' : 'MMM DD,YYYY';
                }

                const dateForJalali = m.toDate();

                if (lang === 'fa') {
                    this.el.nativeElement.innerText = momentJalaali(dateForJalali).format(format);
                } else {
                    this.el.nativeElement.innerText = m.format(format);
                }
            });
    }

    ngOnDestroy(): void {
        this.unsubscribeAll$.next();
        this.unsubscribeAll$.complete();
    }

}